import { useMutation } from '@tanstack/react-query';

import { setPassword } from '../services/auth.service';
import type { SetPasswordPayload } from '../services/auth.service';

/**
 * Mutation for the token-based set-password flow. Kept thin so the calling
 * component owns success/error UX (i18n toast + redirect) where `t` is available.
 */
export function useSetPassword() {
  return useMutation({
    mutationFn: (payload: SetPasswordPayload) => setPassword(payload),
  });
}
